import JsonManager from './JsonManager';

class ContactFormManager {
  constructor(form) {
    this.form = form;
  }

  getName() {
    return this.form.name;
  }

  getEmail() {
    return this.form.email;
  }

  getMessagte() {
    return this.form.message;
  }

  getSubmit() {
    return this.form.submit;
  }
}

class ContactManager {
  constructor() {
    this.contact = JsonManager.getContact();
  }

  getImage() {
    return this.contact.image;
  }

  getTitle() {
    return this.contact.title;
  }

  getMessage() {
    return this.contact.message;
  }

  getName() {
    return this.contact.name;
  }

  getEmail() {
    return this.contact.email;
  }

  getForm() {
    return new ContactFormManager(this.contact.form);
  }
}

export default ContactManager;



// WEBPACK FOOTER //
// ./src/managers/ContactManager.js